
const toOwnerview = r => require.ensure([], () => r(require('@/page/toOwner/toOwnerview')), 'toOwnerview');
const totoOwner = r => require.ensure([], () => r(require('@/page/toOwner/totoOwner')), 'totoOwner');

const totoOwnerRouter = {
    path: '',
    redirect: '/totoOwner',
    name: '业主组织决策系统',
    component: toOwnerview,
    meta: {
        icon: 'expertInfo',
        right: [],
        isShowMenu: true,
    },
    children:[
      {path:'/totoOwner',component:totoOwner,name:'业主组织决策系统',meta: {right:[],isShowMenu:true,keepAlive:true},},
    ]
};
export default totoOwnerRouter;
